import { AxiosError } from 'axios'
import LoadingScreen from 'components/loading-screen'
import { useEffect, useState, VoidFunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import ErrorView from 'components/error-view'
import { useTrivia } from '../../../contexts/trivia-context'
import OptionSelector from './selector'

export interface TriviaGameProps {
  id: number | string
}

const TriviaGame: VoidFunctionComponent<TriviaGameProps> = ({ id }) => {
  const [state, { getTrivia }] = useTrivia()
  const [error, setError] = useState('')
  const history = useHistory()

  useEffect(() => {
    const event = new CustomEvent('background-color', {
      detail: {
        shouldUseWhiteBg: true,
        from: 'trivias game page'
      }
    })

    window.dispatchEvent(event)

    getTrivia(id).catch((error: AxiosError) => {
      if (error.isAxiosError) {
        setError(error.response?.data.code)
      }
    })

    window.onbeforeunload = function () {
      return 'Estás seguro que deseas salir? Perderás el progreso'
    }

    return () => {
      const event = new CustomEvent('background-color', {
        detail: {
          shouldUseWhiteBg: false,
          from: 'trivia exit modal'
        }
      })
      window.onbeforeunload = null
      window.dispatchEvent(event)
    }
  }, [])

  if (error) {
    return <ErrorView code={error as unknown as number ?? 9999} buttonMenu={() => history.goBack()} onRetry={() => history.goBack()} />
  }

  if (!state.currentTrivia) {
    return <LoadingScreen />
  }

  return <OptionSelector trivia={state.currentTrivia} />
}

export default TriviaGame
